import { toast } from "sonner";
import { trpc } from "@/lib/trpc";
import { fetchAddressFromCep } from "@/lib/viacep";
import { soDigitos } from "./formatos";

/** Salva um campo por vez da aba Dados. Vazio vira `null` (o update aceita limpar). */
export function useSalvarPaciente(patientId: string, onSaved: () => void) {
  const utils = trpc.useUtils();
  const update = trpc.patient.update.useMutation({
    onSuccess: () => {
      onSaved();
      utils.patient.list.invalidate();
      utils.patient.listMineAcrossOrgs.invalidate();
    },
    onError: (e) => toast.error(e.message || "Erro ao salvar"),
  });

  const enviar = (data: Record<string, unknown>) => update.mutateAsync({ id: patientId, data });

  const campo = async (field: string, value: unknown, nome: string) => {
    await enviar({ [field]: value });
    toast.success(`${nome} atualizado`, { duration: 1600 });
  };

  return {
    campo,
    texto: (field: string, nome: string) => (v: string) => campo(field, v.trim() || null, nome),
    digitos: (field: string, nome: string) => (v: string) => campo(field, soDigitos(v) || null, nome),
    opcao: (field: string, nome: string) => (v: string) => campo(field, v || null, nome),
    tags: async (tags: string[]) => {
      await enviar({ tags });
      toast.success("Tags atualizadas", { duration: 1600 });
    },
    /** CEP com ViaCEP: preenche logradouro, bairro, cidade e UF quando acha. */
    cep: async (v: string) => {
      const cep = soDigitos(v);
      const data: Record<string, unknown> = { zipCode: cep || null };
      if (cep.length === 8) {
        const via = await fetchAddressFromCep(cep);
        if (via?.address) data.address = via.address;
        if (via?.neighborhood) data.neighborhood = via.neighborhood;
        if (via?.city) data.city = via.city;
        if (via?.state) data.state = via.state;
      }
      await enviar(data);
      const n = Object.keys(data).length - 1;
      toast.success(n > 0 ? `CEP atualizado · ${n} campo${n > 1 ? "s" : ""} preenchido${n > 1 ? "s" : ""} automaticamente` : "CEP atualizado", { duration: 2000 });
    },
  };
}

export type SalvarPaciente = ReturnType<typeof useSalvarPaciente>;
